import { ComponentCanDeactivate } from '../interfaces';
import { CanDeactivateFn } from '@angular/router';

export const pendingChangesGuard: CanDeactivateFn<ComponentCanDeactivate> = (component: ComponentCanDeactivate) => {
    return component.canDeactivate ? component.canDeactivate() : true;
};
